module.exports = __webpack_public_path__ + "img/yanxue_left.6643c867.png";